import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class RemoveRedovisningshanvisningGiltighetCommand extends BasicCommand<RemoveRedovisningshanvisningGiltighetCommand> {
    inmatningshandelssortiment: string;
    arbetsorderId: number;
    mottagningsplatsnummer: string;
    typ?: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "RemoveRedovisningshanvisningGiltighetCommand";

    get primaryKey(): IPrimaryKey<RemoveRedovisningshanvisningGiltighetCommand> {
        return {
            inmatningshandelssortiment: this.inmatningshandelssortiment,
            arbetsorderId: this.arbetsorderId,
            mottagningsplatsnummer: this.mottagningsplatsnummer
        };
    }
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    constructor(init: (instance: RemoveRedovisningshanvisningGiltighetCommand) => void) {
        super(RemoveRedovisningshanvisningGiltighetCommand.$type, RemoveRedovisningshanvisningGiltighetCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
